export const vennHealthConstants = {
    diagnosedOnlyCode: 'DO',
    treatedOnlyCode: 'TO',
    diagnosedOrTreatedOnlyCodes: ['DO', 'TO'],
    colors: {
        male: '#0275d8',
        female: '#e735c9'
    },
    regexPatterns: {
        numericOnly: '^\\d+$',
        numericWithDecimal: '^\\d*\\.?\\d*$'
    },
    nHanesYears: [
        { text: '2003-2004', value: 3 },
        { text: '2005-2006', value: 4 },
        { text: '2007-2008', value: 5 },
        { text: '2009-2010', value: 6 },
        { text: '2011-2012', value: 7 },
        { text: '2013-2014', value: 8 },
        { text: '2015-2016', value: 9 },
        { text: '2017-2020', value: 66 }
    ],
    // demoDataSetYears: [
    //     { text: '2003-2004', value: 3 }
    // ],
    indicationGroups: [
        'Cardiology',
        'Infectious Disease',
        'Respiratory',
        'Sleep Disorders',
        'Urology',
        'Other Diseases',
        'Other Measures'
    ],
    customControlIndications: {
        dyslipidemia: 'dyslipidemia',
        hypertension: 'hypertension',
        insomnia: 'insomnia',
        renalDysfunction: 'renalDysfunction',
        diabetes: 'diabetes',
        tenYearRiskOfCHDFraminghamScore: 'tenYearRiskOfCHDFraminghamScore',
        metabolicSyndrome: 'metabolicSyndrome',
        albumin: 'albumin'
    },
    allIndications: [
        {
            name: 'cardiology',
            displayName: 'Cardiology',
            order: 1,
            demo: false,
            indications: [
                {
                    name: 'angina',
                    displayName: 'Angina/angina pectoris',
                    code: 'ANGINA',
                    definition: 'Angina pectoris is a clinical syndrome of precordial discomfort or pressure due to transient myocardial ischemia without infarction. The Rose questionnaire for angina pectoris is a validated instrument for use in the general population. The Rose criteria includes information about any chest pain, and then specifically about chest pain brought on by exertion.',
                    order: 1,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Diagnosed = age 20+; Rose Criteria = age 40+',
                    units: '',
                    selections: [],
                    inputOptions: [
                        {name: 'DO', displayName: 'Diagnosed Only', order: 1, defaultValue: 'MC'},
                        {name: 'MC', displayName: 'Meets Rose Criteria (All Patients)', order: 2, defaultValue: 'MC'},
                        {name: 'UO', displayName: 'Undiagnosed Only (Meets Rose Criteria)', order: 3, defaultValue: 'MC'},
                        {name: 'DU', displayName: 'Diagnosed + Undiagnosed (Meets Rose Criteria)', order: 4, defaultValue: 'MC'}
                    ]
                },
                {
                    name: 'congestiveHeartFailure',
                    displayName: 'Congestive heart failure',
                    code: 'MCQ160B',
                    definition: 'Congestive heart failure is a life-threatening condition in which the heart can no longer pump enough blood to the rest of the body. Congestive heart failure is almost always a chronic, long-term condition, although it can sometimes develop suddenly. This condition may affect the right side, the left side, or both sides of the heart.',
                    order: 2,
                    selected: false,
                    diagnosedOnly: true,
                    inclusionCriteria: 'Diagnosed = age 20+',
                    units: '',
                    selections: [],
                    inputOptions: []
                },
                {
                    name: 'coronaryHeartDisease',
                    displayName: 'Coronary heart disease',
                    code: 'MCQ160C',
                    definition: 'Coronary heart disease (CHD) is a narrowing of the small blood vessels that supply blood and oxygen to the heart. Coronary heart disease is usually caused by atherosclerosis. As the coronary arteries narrow, blood flow to the heart can slow down or stop, causing chest pain (stable angina), shortness of breath, myocardial infarction, or other symptoms.',
                    order: 3,
                    selected: false,
                    diagnosedOnly: true,
                    inclusionCriteria: 'Diagnosed = age 20+',
                    units: '',
                    selections: [],
                    inputOptions: []
                },
                {
                    name: 'cReactiveProtein',
                    displayName: 'C-reactive protein',
                    code: 'LBXCRP',
                    definition: 'C-reactive protein is a test that measures the amount of a protein in the blood that signals acute inflammation. The systemic inflammation may be due to a variety of different conditions including: cancer, connective tissue disease, myocardial infarction, infection, inflammatory bowel disease (IBS), lupus, pneumococcal pneumonia, rheumatoid arthritis, rheumatic fever, and tuberculosis.',
                    order: 4,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Lab values = age 3+',
                    units: 'mg/dL',
                    selections: [],
                    inputOptions: [
                        {name: 'maleLowerLimits', displayName: 'Male Lower Limits', order: 1, defaultValue: 1, details: '(>)'},
                        {name: 'femaleLowerLimits', displayName: 'Female Lower Limits', order: 2, defaultValue: 1, details: '(>)'}
                    ]
                },
                {
                    name: 'dyslipidemia',
                    displayName: 'Dyslipidemia',
                    code: 'HYPERCHOL',
                    definition: 'Dyslipidemias can be characterized by increases in cholesterol only (isolated hypercholesterolemia), increases in triglycerides (TGs) only (isolated hypertriglyceridemia), or increases in both cholesterol and TGs (mixed hyperlipidemias). Additionally, dyslipidemias can take into account specific lipoprotein abnormalities (eg, low HDL or high LDL) that may contribute to disease despite normal cholesterol and TG levels. Routine measurements (lipid profile) include total cholesterol (TC), TGs, HDL, and LDL.',
                    order: 5,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Diagnosed = age 20+; Lab values - HDL & Total cholesterol = age 6+; Lab values - LDL & Triglycerides = age 12+',
                    units: 'mg/dL',
                    selections: [],
                    inputOptions: [
                        {name: 'DO', displayName: 'Diagnosed Only', order: 1, defaultValue: 'DU'},
                        {name: 'MC', displayName: 'Meets Criteria (All Patients)', order: 2, defaultValue: 'DU'},
                        {name: 'UO', displayName: 'Undiagnosed Only (Meets Criteria)', order: 3, defaultValue: 'DU'},
                        {name: 'DU', displayName: 'Diagnosed + Undiagnosed (Meets Criteria)', order: 4, defaultValue: 'DU'}
                    ]
                },
                {
                    name: 'hypertension',
                    displayName: 'Hypertension',
                    code: 'HYP',
                    definition: 'Hypertension is a sustained elevation of resting systolic BP (≥ 140 mm Hg), diastolic BP (≥ 90 mm Hg), or both. Hypertension with no known cause (primary; formerly, essential hypertension) is most common. Hypertension with an identified cause (secondary hypertension) is usually due to a renal disorder.',
                    order: 6,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Diagnosed and/or treated = age 16+; Lab values = age 8+',
                    units: 'mm Hg',
                    selections: [],
                    inputOptions: [
                        {name: 'DO', displayName: 'Diagnosed Only', order: 1, defaultValue: 'DU'},
                        {name: 'MC', displayName: 'Meets Criteria (All Patients)', order: 2, defaultValue: 'DU', checkbox: [
                                { name: 'MC', displayName: 'Meets Criteria Only', order: 1},
                                { name: 'MC_AM', displayName: 'Add patients taking medication', order: 2 }, 
                                { name: 'MC_LM', displayName: 'Limit to patients taking medication', order: 3}
                            ]
                        },
                        {name: 'UO', displayName: 'Undiagnosed Only (Meets Criteria)', order: 3, defaultValue: 'DU'},
                        {name: 'DU', displayName: 'Diagnosed + Undiagnosed (Meets Criteria)', order: 4, defaultValue: 'DU'},
                        {name: 'TO', displayName: 'Treated Patients Only', order: 5, defaultValue: 'DU'}
                    ]
                },
                {
                    name: 'myocardialInfarction',
                    displayName: 'Myocardial infarction',
                    code: 'MCQ160E',
                    definition: 'Myocardial infarction (MI), colloquially known as “heart attack,” is caused by decreased or complete cessation of blood flow to a portion of the myocardium. Prolonged deprivation of oxygen supply to the myocardium can lead to myocardial cell death and necrosis. Myocardial ischemia may be associated with ECG changes and elevated biochemical markers such as cardiac troponins.',
                    order: 7,
                    selected: false,
                    diagnosedOnly: true,
                    inclusionCriteria: 'Diagnosed = age 20+',
                    units: '',
                    selections: [],
                    inputOptions: []
                },
                {
                    name: 'stroke',
                    displayName: 'Stroke',
                    code: 'MCQ160F',
                    definition: 'Strokes are a heterogeneous group of disorders involving sudden, focal interruption of cerebral blood flow that causes neurologic deficit. Strokes can be ischemic (80%), typically resulting from thrombosis or embolism, or hemorrhagic (20%), resulting from vascular rupture.',
                    order: 8,
                    selected: false,
                    diagnosedOnly: true,
                    inclusionCriteria: 'Diagnosed = age 20+',
                    units: '',
                    selections: [],
                    inputOptions: []
                }
            ]
        },
        // {
        //     name: 'infectiousDisease',
        //     displayName: 'Infectious Disease',
        //     order: 2,
        //     indications: [
        //         {
        //             name: 'hepatitis',
        //             displayName: 'Hepatitis',
        //             code: 'HEP',
        //             definition: 'Hepatitis is an inflammation of the liver characterized by diffuse or patchy necrosis. Hepatitis A is transmitted by contaminated food or water, or contact with a person who is currently ill with the disease. Other common hepatitis virus infections include hepatitis B and hepatitis C, but hepatitis A is the least serious and most mild of these diseases. Both of the others may become chronic illnesses, but hepatitis A does not. The hepatitis B virus spreads through blood and other body fluids and most of the damage from the hepatitis B virus is due to the body\'s response to the infection.  Hepatitis C virus (HCV) can persist for many years and cause cirrhosis or liver cancer.  Hepatitis D virus (HDV) is only found in people who carry the hepatitis B virus. HDV may make a hepatitis B infection or existing hepatitis B liver more severe.',
        //             order: 1,
        //             selected: false,
        //             diagnosedOnly: false,
        //             selections: [],
        //             controlLabelName: 'Select criteria to include',
        //             inputOptions: [
        //                 // {name: 'All', displayName: 'Select All', order: 0, items: [
        //                 //         {name: 'BCoreAntibody', displayName: 'Hepatitis B core antibody', order: 1},
        //                 //         {name: 'BsurfaceAntigen', displayName: 'Hepatitis B surface antigen', order: 2},
        //                 //         {name: 'CAntibody', displayName: 'Hepatitis C antibody', order: 3},
        //                 //         {name: 'D', displayName: 'Hepatitis D', order: 4}
        //                 //     ]
        //                 // }
        //             ]
        //         }
        //         // {
        //         //     name: 'hiv',
        //         //     displayName: 'HIV',
        //         //     code: 'LBDHI',
        //         //     definition: 'Human immunodeficiency virus (HIV) infection results from 1 of 2 similar retroviruses (HIV-1 and HIV-2) that destroy CD4+ lymphocytes and impair cell-mediated immunity, increasing risk of certain infections and cancers. Initial infection may produce nonspecific febrile illness. The risk of subsequent manifestations—related to immunodeficiency—is proportional to the level of CD4+ lymphocytes. Manifestations range from asymptomatic carriage to the acquired immune deficiency syndrome (AIDS), which is defined by serious opportunistic infections or cancers. HIV infection is diagnosable by antibody or antigen testing.',
        //         //     order: 2,
        //         //     selected: false,
        //         //     diagnosedOnly: true,
        //         //     selections: [],
        //         //     inputOptions: []
        //         // }
        //     ]
        // },
        {
            name: 'respiratory',
            displayName: 'Respiratory',
            order: 2,
            demo: false,
            indications: [
                {
                    name: 'asthma',
                    displayName: 'Asthma',
                    code: 'asthma',
                    definition: 'Asthma is a diffuse inflammatory disorder of the airways caused by a variety of triggering stimuli resulting in partially or completely reversible bronchoconstriction, Symptoms and signs include dyspnea, chest tightness, cough, and wheezing. The diagnosis is based on history, physical examination, and pulmonary function tests.',
                    order: 1,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Diagnosed = age 1+',
                    units: '',
                    selections: [],
                    inputOptions: [
                        {name: 'current', displayName: 'Current', order: 1, defaultValue: 'current'},
                        {name: 'lifetime', displayName: 'Lifetime', order: 2, defaultValue: 'current'}
                    ]
                },
                {
                    name: 'copd',
                    displayName: 'COPD',
                    code: 'COPD',
                    definition: 'Chronic obstructive pulmonary disease, or COPD, comprises a combination of chronic and slowly progressive respiratory disorders including emphysema, small airway disease, and chronic bronchitis. Clinically, COPD can be described as persistent respiratory symptoms with significant airflow limitation, as measured by reduced maximal expiratory flow during forced exhalation. A key characteristic of COPD is the incomplete reversibility of airway obstruction, which may differ from other conditions such as asthma, in which airway obstruction is commonly reversible with bronchodilators.',
                    order: 2,
                    selected: false,
                    diagnosedOnly: true,
                    inclusionCriteria: 'Diagnosed = age 20+',
                    units: '',
                    selections: [],
                    inputOptions: []
                },
                // {
                //     name: 'emphysema',
                //     displayName: 'Emphysema',
                //     code: 'MCQ160G',
                //     definition: 'Emphysema is destruction of lung parenchyma leading to loss of elastic recoil and loss of alveolar septa and radial airway traction, which increases the tendency for airway collapse. Lung hyperinflation, airflow limitation, and air trapping follow. Airspaces enlarge and may eventually develop bullae.',
                //     order: 2,
                //     selected: false,
                //     diagnosedOnly: true,
                //     selections: [],
                //     inputOptions: []
                // },
                // {
                //     name: 'chronicBronchitis',
                //     displayName: 'Chronic Bronchitis',
                //     code: 'chronicBronchitis',
                //     definition: 'Chronic bronchitis is an inflammation of the main airways in the lungs that results in a productive cough for at least 3 months total duration in 2 successive years. The symptoms must not be caused by any other disease or condition.',
                //     order: 3,
                //     selected: false,
                //     diagnosedOnly: false,
                //     selections: [],
                //     inputOptions: [
                //         {name: 'current', displayName: 'Current', order: 1, defaultValue: 'current'},
                //         {name: 'lifetime', displayName: 'Lifetime', order: 2, defaultValue: 'current'}
                //     ]
                // }
            ]
        },
        // {
        //     name: 'sleepDisorders',
        //     displayName: 'Sleep Disorders',
        //     order: 4,
        //     indications: [
        //         {
        //             name: 'sleepApnea',
        //             displayName: 'Sleep Apnea',
        //             code: 'SLQ070A',
        //             definition: 'Sleep apnea is a heterogeneous group of conditions characterized by changes in ventilatory drive without airway obstruction; most of these conditions cause asymptomatic changes in breathing pattern during sleep.',
        //             order: 1,
        //             selected: false,
        //             diagnosedOnly: true,
        //             selections: [],
        //             inputOptions: []
        //         },
        //         {
        //             name: 'insomnia',
        //             displayName: 'Insomnia',
        //             code: 'INS',
        //             definition: 'Insomnia is defined as poor-quality sleep because of one or more of the following: difficulty falling asleep; waking up frequently during the night with difficulty returning to sleep; waking up too early in the morning; or unrefreshing sleep.',
        //             order: 2,
        //             selected: false,
        //             diagnosedOnly: false,
        //             selections: [],
        //             inputOptions: [
        //                 {name: 'DO', displayName: 'Diagnosed Only', order: 1, defaultValue: 'DU'},
        //                 {name: 'MC', displayName: 'Meets Criteria (All Patients)', order: 2, defaultValue: 'DU'},
        //                 {name: 'UO', displayName: 'Undiagnosed Only (Meets Criteria)', order: 3, defaultValue: 'DU'},
        //                 {name: 'DU', displayName: 'Diagnosed + Undiagnosed (Meets Criteria)', order: 4, defaultValue: 'DU'}
        //             ]
        //         },
        //         {
        //             name: 'restlessLegs',
        //             displayName: 'Restless Legs',
        //             code: 'SLQ070C',
        //             definition: 'Restless legs is a sensorimotor disorder characterized by an irresistible urge to move the legs, usually accompanied by paresthesias (eg, creeping or crawling sensations) and sometimes pain in the upper or lower extremities, which are more prominent when patients are inactive or recline, and peak in severity around bedtime.',
        //             order: 3,
        //             selected: false,
        //             diagnosedOnly: true,
        //             selections: [],
        //             inputOptions: []
        //         }
        //     ]
        // },
        {
            name: 'otherDiseases',
            displayName: 'Other Diseases',
            order: 3,
            demo: true,
            indications: [
                // {
                //     name: 'renalDysfunction',
                //     displayName: 'Renal Dysfunction',
                //     code: 'KIQ022',
                //     definition: 'Renal failure is the loss of the ability of the kidneys to remove waste and concentrate urine without losing electrolytes. Renal failure can occur suddenly (acute renal failure), or in a slow and progressive fashion.  Chronic renal failure most often results from any disease that causes gradual loss of kidney function. It can range from mild dysfunction to severe kidney failure. The disease may lead to end-stage renal disease (ESRD).',
                //     order: 1,
                //     selected: false,
                //     diagnosedOnly: true,
                //     selections: [],
                //     inputOptions: []
                // },
                {
                    name: 'hepatitis',
                    displayName: 'Hepatitis',
                    code: 'HEP',
                    definition: 'Hepatitis is an inflammation of the liver characterized by diffuse or patchy necrosis. Hepatitis A is transmitted by contaminated food or water, or contact with a person who is currently ill with the disease. Other common hepatitis virus infections include hepatitis B and hepatitis C, but hepatitis A is the least serious and most mild of these diseases. Both of the others may become chronic illnesses, but hepatitis A does not. The hepatitis B virus spreads through blood and other body fluids and most of the damage from the hepatitis B virus is due to the body\'s response to the infection. Hepatitis C virus (HCV) can persist for many years and cause cirrhosis or liver cancer. Hepatitis D virus (HDV) is only found in people who carry the hepatitis B virus. HDV may make a hepatitis B infection or existing hepatitis B liver more severe.',
                    order: 1,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Hep A test results = age 3+; Hep B core antibody, Hep B surface antigen, Hep C antibody, Hep D test results = age 6+',
                    units: '',                    
                    selections: [],
                    controlLabelName: 'Select criteria to include',
                    inputOptions: []
                },
                {
                    name: 'ckd',
                    displayName: 'CKD',
                    code: 'CKD',
                    definition: 'Chronic kidney disease is the loss of the ability of the kidneys to remove waste and concentrate urine without losing electrolytes. Renal failure can occur suddenly (acute renal failure), or in a slow and progressive fashion. Chronic renal failure most often results from any disease that causes gradual loss of kidney function. It can range from mild dysfunction to severe kidney failure. The disease may lead to end-stage renal disease (ESRD).',
                    order: 2,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Diagnosed = age 20+; Lab values - UACR = 6+; GFR = age 12+',
                    units: 'GFR = mL/min/1.73m^2; UACR = mg/g',
                    selections: [],
                    inputOptions: [
                        {name: 'DO', displayName: 'Diagnosed Only', order: 1, defaultValue: 'DU'},
                        {name: 'MC', displayName: 'Meets Criteria (All Patients)', order: 2, defaultValue: 'DU'},
                        {name: 'UO', displayName: 'Undiagnosed Only (Meets Criteria)', order: 3, defaultValue: 'DU'},
                        {name: 'DU', displayName: 'Diagnosed + Undiagnosed (Meets Criteria)', order: 4, defaultValue: 'DU'}
                    ]
                },
                {
                    name: 'arthritis',
                    displayName: 'Arthritis',
                    code: 'ART',
                    definition: 'Arthritis is inflammation of one or more joints, which results in pain, swelling, stiffness, and limited movement. Rheumatoid arthritis is a chronic systemic autoimmune disease that primarily involves the joints. RA causes damage mediated by cytokines, chemokines, and metalloproteases. Osteoarthritis is a chronic arthropathy characterized by disruption and potential loss of joint cartilage along with other joint changes, including bone hypertrophy (osteophyte formation). Psoriatic arthritis is a chronic, immune-mediated, inflammatory arthropathy that presents with inflammation of the joints and entheses, including those of the axial skeleton, and is associated with increased mortality from cardiovascular disease.',
                    order: 3,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Meets criteria = age 20+',
                    units: '',
                    selections: [],
                    controlLabelName: 'Include the following type(s)',
                    inputOptions: [
                        { name: 'All', displayName: 'Select All', order: 0, items: [
                                {name: 'Osteoarthritis', displayName: 'Osteoarthritis', order: 1},
                                {name: 'RheumatoidArthritis', displayName: 'Rheumatoid Arthritis', order: 2},
                                {name: 'PsoriaticArthritis', displayName: 'Psoriatic Arthritis', order: 3},
                                {name: 'Other', displayName: 'Other', order: 4},
                                {name: 'DoNotKnow', displayName: 'Do Not Know', order: 5}
                            ]
                        }
                    ]
                },
                {
                    name: 'depression',
                    displayName: 'Depression',
                    code: 'DEP',
                    definition: 'Depression is characterized by a pervasive and abnormal mood state consisting of sadness or irritability that is severe or persistent enough to interfere with functioning or cause considerable distress. Decreased interest or pleasure in activities may be as or even more apparent than the mood abnormalities. The Patient Health Questionnaire (PHQ-9) contains a brief, 9-item, patient self-reported depression assessment specifically developed for use in primary care. The PHQ-9 has demonstrated usefulness as an assessment tool for the diagnosis of depression in primary care with acceptable reliability, validity, sensitivity, and specificity. The nine items of the PHQ-9 come directly from the nine DSM-IV signs and symptoms of major depression and can be used to classify patients as mild, moderate or severe.',
                    order: 4,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Meets criteria = age 18+',
                    units: '',
                    selections: [],
                    controlLabelName: 'Include the following segments',
                    inputOptions: [
                        { name: 'All', displayName: 'Select All', order: 0, items: [
                                {name: 'Mild', displayName: 'Mild', order: 1},
                                {name: 'Moderate', displayName: 'Moderate', order: 2},
                                {name: 'ModeratelySevere', displayName: 'Moderately Severe', order: 3},
                                {name: 'Severe', displayName: 'Severe', order: 4}
                            ]
                        }
                    ]
                },
                {
                    name: 'diabetes',
                    displayName: 'Diabetes',
                    code: 'DIAB',
                    definition: 'Diabetes mellitus is impaired insulin secretion and variable degrees of peripheral insulin resistance leading to hyperglycemia. There are 2 main categories of diabetes mellitus (DM)—type 1 and type 2, which can be distinguished by a combination of features such as: age at onset, associated obesity, plasma levels of endogenous insulin, islet pathology, and response to oral antihyperglycemic drugs.',
                    order: 5,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Diabetes diagnosed and/or treated = age 1+; Prediabetes diagnosed and/or treated = age 12+; Lab value - Fasting Plasma Glucose & Glycohemoglobin = age 12+',
                    units: 'Glycohemoglobin = %; Fasting Plasma Glucose = mg/dL',
                    selections: [],
                    inputOptions: []
                }
            ]
        },
        {
            name: 'otherMeasures',
            displayName: 'Other Measures',
            order: 4,
            demo: false,
            indications: [
                {
                    name: 'age',
                    displayName: 'Age',
                    code: 'AGE',
                    definition: 'Age in years of each NHANES participant at the time of screening was recorded. Individuals from age 0 to age 80 and over are included and are top-coded at 80+ years of age.',
                    order: 1,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'NHanes age range = 0-85',
                    units: '',
                    selections: [],
                    inputOptions: []
                },
                // {
                //     name: 'tenYearRiskOfCHDFraminghamScore',
                //     displayName: '10-year risk of CHD (Framingham Score)',
                //     code: 'FRAM',
                //     definition: 'The Framingham score is a coronary prediction algorithm that provides estimates of total CHD risk (risk of developing one of the following: angina pectoris, myocardial infarction, or coronary disease death) over the course of 10 years.  The factors used to estimate risk include age, HDL cholesterol, blood pressure, cigarette smoking, and diabetes mellitus',
                //     order: 2,
                //     selected: false,
                //     diagnosedOnly: false,
                //     selections: [],
                //     inputOptions: []
                // },
                {
                    name: 'metabolicSyndrome',
                    displayName: 'Metabolic Syndrome',
                    code: 'MBS',
                    definition: 'Metabolic syndrome, also called syndrome X, is characterized by excess abdominal fat causing insulin resistance, dyslipidemia, and hypertension. Any three of the following traits in the same individual meet the criteria for the metabolic syndrome: abdominal obesity (a waist circumference over 102 cm/40 inches in men and over 88 cm/35 inches in women), serum triglycerides 150 mg/dl or above, HDL cholesterol 40mg/dl or lower in men and 50mg/dl or lower in women, blood pressure of 130/85 or more, and fasting blood glucose of 100 mg/dl or above.',
                    order: 2,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Lab value - waist = age 2+; Lab value - Glucose = age 12+; Lab value - BP = age 8+; Lab value - HDL = age 6+; Lab value - Triglycerides = age 12+',
                    units: 'Waist = cm; BP = mm Hg; Glucose, HDL, Triglycerides = mg/dL;',
                    selections: [],
                    controlLabelName: '',
                    inputOptions: []
                },
                {
                    name: 'bmi',
                    displayName: 'Body Mass Index',
                    code: 'BMXBMI',
                    definition: 'Body Mass Index (BMI) is a relationship between weight and height that is associated with body fat and health risk. The equation for BMI is body weight in kilograms divided by height in meters squared. Although BMI can be used for most men and women, it does have some limits, including: it may overestimate body fat in athletes and others who have a muscular build; it may underestimate body fat in older persons and others who have lost muscle.',
                    order: 3,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Lab value = age 2+',
                    units: 'kg/m²',
                    selections: [],
                    controlLabelName: 'Include the following segments',
                    inputOptions: [
                        {name: 'maleLowerLimits', displayName: 'Male Lower Limits', order: 1, defaultValue: 25, maxlength: 5, details: '(>=)'},
                        {name: 'femaleLowerLimits', displayName: 'Female Lower Limits', order: 2, defaultValue: 25, maxlength: 5, details: '(>=)'}
                    ]
                },
                {
                    name: 'bodyWeight',
                    displayName: 'Body Weight',
                    code: 'BMXWT',
                    definition: 'Weight is a body measure that can be used to monitor trends in infant and child growth, to estimate the prevalence of overweight and obesity in U.S. children, adolescents, and adults, and to examine the associations with the health of the U.S. population.',
                    order: 4,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Diagnosed = age 16+; Lab value = age 0+',
                    units: 'kg',
                    selections: [],
                    controlLabelName: 'Disease Criteria',
                    inputOptions: []
                },
                {
                    name: 'waistCircumference',
                    displayName: 'Waist Circumference',
                    code: 'BMXWAIST',
                    definition: 'Waist circumference is an important factor in weight and body-fat assessment. Total body fat is not the sole indicator of weight-related health problems and fat distribution is deemed just as important. Body fat that accumulates around the waist and stomach area (abdominal fat) poses a greater health risk than fat stored in the lower half of the body.',
                    order: 5,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Lab value = age 2+',
                    units: 'cm',
                    selections: [],
                    inputOptions: [
                        {name: 'maleLowerLimits', displayName: 'Male Lower Limits', order: 1, defaultValue: 101.6, maxlength: 5, details: '(>)'},
                        {name: 'femaleLowerLimits', displayName: 'Female Lower Limits', order: 2, defaultValue: 88.9, maxlength: 5, details: '(>)'}
                    ]
                },
                {
                    name: 'albumin',
                    displayName: 'Albumin (urine or serum)',
                    code: 'AB',
                    definition: 'Since albumin is low in many different diseases and disorders, albumin testing is used in a variety of settings to help diagnose disease, to monitor changes in health status with treatment or with disease progression, and as a screen that may serve as an indicator for other kinds of testing. Low albumin levels can suggest liver disease. Other liver enzyme tests are ordered to determine exactly which type of liver disease. Low albumin levels can reflect diseases in which the kidneys cannot prevent albumin from leaking from the blood into the urine and being lost. In this case, the amount of albumin (or protein) in the urine also may be measured. Low albumin levels can also be seen in inflammation, shock, and malnutrition. Low albumin levels may also suggest conditions in which the body does not properly absorb and digest protein (like Crohn’s disease or sprue) or in which large volumes of protein are lost from the intestines. High albumin levels usually reflect dehydration.',
                    order: 6,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Lab value - urine = age 6+; Lab value - serum = age 12+',
                    units: 'Urine = ug/mL; Serum = g/dL',
                    selections: [],
                    inputOptions: []
                },
                {
                    name: 'creatinine',
                    displayName: 'Creatinine',
                    code: 'LBXSCR',
                    definition: 'The creatinine blood test is usually ordered along with a BUN (blood urea nitrogen) test to assess kidney function. Both are frequently ordered as part of a basic or comprehensive metabolic panel (BMP or CMP), groups of tests that are performed to evaluate the function of the body’s major organs. BMP or CMP tests are ordered on healthy people during routine physical exams and on acutely or chronically ill patients in the emergency room and/or hospital. If the creatinine and BUN tests are found to be abnormal or if the patient has an underlying disease, such as diabetes, that is known to affect the kidneys, then these two tests may be used to monitor the progress of kidney dysfunction and the effectiveness of treatment. Blood creatinine and BUN tests may also be ordered to evaluate kidney function prior to some procedures, such as a CT (computed tomography) scan, that may require the use of drugs that can damage the kidneys. A combination of blood and urine creatinine levels may be used to calculate a creatinine clearance. This measures how effectively the kidneys are filtering small molecules like creatinine out of the blood. Urine creatinine may also be used with a variety of other urine tests as a sort of correction factor. Since it is produced and removed at a relatively constant rate, the amount of urine creatinine can be compared to the amount of the other substance (such as protein) being measured.',
                    order: 7,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Lab value - serum = age 12+',
                    units: 'mg/dL',
                    selections: [],
                    inputOptions: [
                        {name: 'maleLowerLimits', displayName: 'Male Lower Limits', order: 1, defaultValue: 1.2, maxlength: 4, details: '(>)'},
                        {name: 'femaleLowerLimits', displayName: 'Female Lower Limits', order: 2, defaultValue: 1, maxlength: 4, details: '(>)'}
                    ]
                },
                {
                    name: 'smoking',
                    displayName: 'Smoking',
                    code: 'SMQ',
                    definition: 'Smoking can be defined as persons who currently smoke, or those that have ever smoked in their lifetime (at least 100 cigarettes).',
                    order: 8,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Smoked 100 or currently smoking = age 20+',
                    units: '',
                    selections: [],
                    inputOptions: [
                        {name: 'current', displayName: 'Current', order: 1, defaultValue: 'current'},
                        {name: 'lifetime', displayName: 'Lifetime (100 cigarettes or more)', order: 2, defaultValue: 'current'}
                    ]
                },
                {
                    name: 'eosinophilsNumber',
                    displayName: 'Eosinophils number',
                    code: 'EN',
                    definition: 'Eosinophils are a kind of blood granulocytes that express cytoplasmic granules that contain basic proteins and bind with acidic dyes like "eosin." They derive from bone marrow, and their production is stimulated by IL-5, IL-3, and GM-CSF. They have a circulating half-life of 4.5 to 8 hours. They can reside in tissues, mostly in the respiratory tract, and gastrointestinal tract, for 8 to 12 days. Eosinophils are less than 5% of circulating leukocytes. Eosinophilia is defined as an increase of circulating eosinophils >0.5 x 1000 cells /uL',
                    order: 8,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Lab value = age 1+',
                    units: '1000 cells/uL',
                    selections: [],
                    inputOptions: [
                        {name: 'lowerLimits', displayName: 'Lower Limits', order: 1, defaultValue: 0.5, maxlength: 4, details: '(>)'}
                    ]
                },
                {
                    name: 'hemoglobin',
                    displayName: 'Hemoglobin',
                    code: 'HG',
                    definition: 'Hemoglobin (Hb) is the protein contained in red blood cells that is responsible for delivery of oxygen to the tissues. To ensure adequate tissue oxygenation, a sufficient hemoglobin level must be maintained. The amount of hemoglobin in whole blood is expressed in grams per deciliter (g/dl). The normal Hb level for males is 14 to 18 g/dl; that for females is 12 to 16 g/dl. When the hemoglobin level is low, the patient has anemia.',
                    order: 8,
                    selected: false,
                    diagnosedOnly: false,
                    inclusionCriteria: 'Lab value = age 1+',
                    units: 'g/dL',
                    selections: [],
                    inputOptions: [
                        {name: 'maleUpperLimits', displayName: 'Male Upper Limits', order: 1, defaultValue: 13.5, maxlength: 4, details: '(<)'},
                        {name: 'femaleUpperLimits', displayName: 'Female Upper Limits', order: 2, defaultValue: 12.0, maxlength: 4, details: '(<)'}
                    ]
                }
            ]
        }
    ],
    searchIndications: [
        {
            name: 'Angina/angina pectoris', 
            sectionName: 'Cardiology', 
            keywords: [
                'angina', 'pectoris', 'precordial discomfort', 'rose criteria', 'chest pain'
            ]
        },
        {
            name: 'Congestive heart failure', 
            sectionName: 'Cardiology', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Coronary heart disease', 
            sectionName: 'Cardiology', 
            keywords: [
                ''
            ]
        },
        {
            name: 'C-reactive protein', 
            sectionName: 'Cardiology', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Dyslipidemia', 
            sectionName: 'Cardiology', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Hypertension', 
            sectionName: 'Cardiology', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Myocardial infarction', 
            sectionName: 'Cardiology', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Stroke', 
            sectionName: 'Cardiology', 
            keywords: [
                ''
            ]
        },
        // {
        //     name: 'HIV', 
        //     sectionName: 'Infectious Disease', 
        //     keywords: [
        //         ''
        //     ]
        // },
        {
            name: 'Asthma', 
            sectionName: 'Respiratory', 
            keywords: [
                ''
            ]
        },
        {
            name: 'COPD', 
            sectionName: 'Respiratory', 
            keywords: [
                'Emphysema', 'Chronic Bronchitis'
            ]
        },
        // {
        //     name: 'Emphysema', 
        //     sectionName: 'Respiratory', 
        //     keywords: [
        //         ''
        //     ]
        // },
        // {
        //     name: 'Chronic Bronchitis', 
        //     sectionName: 'Respiratory', 
        //     keywords: [
        //         ''
        //     ]
        // },
        // {
        //     name: 'Sleep Apnea', 
        //     sectionName: 'Sleep Disorders', 
        //     keywords: [
        //         ''
        //     ]
        // },
        // {
        //     name: 'Insomnia', 
        //     sectionName: 'Sleep Disorders', 
        //     keywords: [
        //         ''
        //     ]
        // },
        // {
        //     name: 'Restless Legs', 
        //     sectionName: 'Sleep Disorders', 
        //     keywords: [
        //         ''
        //     ]
        // },
        {
            name: 'Hepatitis', 
            sectionName: 'Other Diseases', 
            keywords: [
                ''
            ]
        },
        {
            name: 'CKD', 
            sectionName: 'Other Diseases', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Arthritis', 
            sectionName: 'Other Diseases', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Depression', 
            sectionName: 'Other Diseases', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Diabetes', 
            sectionName: 'Other Diseases', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Age', 
            sectionName: 'Other Measures', 
            keywords: [
                ''
            ]
        },
        // {
        //     name: '10-year risk of CHD (Framingham Score)', 
        //     sectionName: 'Other Measures', 
        //     keywords: [
        //         ''
        //     ]
        // },
        {
            name: 'Metabolic Syndrome', 
            sectionName: 'Other Measures', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Body Mass Index', 
            sectionName: 'Other Measures', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Body Weight', 
            sectionName: 'Other Measures', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Waist Circumference', 
            sectionName: 'Other Measures', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Albumin', 
            sectionName: 'Other Measures', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Creatinine', 
            sectionName: 'Other Measures', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Smoking', 
            sectionName: 'Other Measures', 
            keywords: [
                ''
            ]
        },
        {
            name: 'Eosinophils number', 
            sectionName: 'Other Measures', 
            keywords: [
                'eosinophiles',
                'acidophils',
                'eosinocyte',
                'eosinophilic'
            ]
        },
        {
            name: 'Hemoglobin', 
            sectionName: 'Other Measures', 
            keywords: [
                'Hb',
                'haemoglobin',
                'hemoprotein',
                'haem',
                'haematohiston',
                'hematohiston',
                'oxyhemoglobin'
            ]
        }
    ]
};
